import { Box } from "@mui/material";
import { IPreviewTabContentProps } from "./preview-tabs";
import { QuotaConfig } from "../../../Pages/admin/Inventory/InventoryAssetSingle/AssetSingleQuotas/asset-single-quotas";

const QuotasTab = (props: IPreviewTabContentProps) => {
  const { asset } = props;

  return (
    <Box py={2} px={3}>
      <QuotaConfig asset={asset} />
    </Box>
  );
};

export default QuotasTab;
